import { useState } from 'react';
import { SelectedItem } from '../../../../types/aggregating';

export const useSelection = () => {
  const [selection, setSelection] = useState<SelectedItem>({
    selection: '',
    selectionName: '',
    discountedPrice: 0,
    price: 0,
    soldOut: false,
    occupancy: {
      totalOccupancy: 0,
      totalUnitsRemaining: 0,
      availabilityLabel: '',
    },
  });

  return {
    selection,
    setSelection,
  };
};
